import { Button, Text } from 'components';
import Footer from 'components/Footer';
import React from 'react';
import Overly from '../assets/images/overly.png';
import { useNavigate } from 'react-router-dom';

const NotFound = () => {
  const navigate = useNavigate()
  return (
    <>
    <div className="min-h-screen bg-white flex flex-col justify-center items-center text-center px-4 relative overflow-hidden">
    <img src={Overly} className='overlyClassName z-0 left-[30em]'  alt="Logo" />
    <img src={Overly} className='overlyClassName z-0 right-[30em]'  alt="Logo" />

      <div className="error animate-bounce">
      <h1 className="text-[15em] text-[#747EEF] sm:text-6xl md:text-7xl lg:text-8xl xl:text-9xl">
  404
</h1>
      </div>
      <p className="text-[black] text-xl mt-4 sm:text-lg md:text-xl ">Page Not Found</p>

    
      <Button onClick={()=> navigate('/')}   shape="round" className="min-w-[140px] sm:px-1 mt-3 z-50" style={{fontSize:'17px',background:'#747EEF',color:'white'}}>
      Back to Home
                  </Button>
     
    </div>
    <Footer/>
    </>
  );
};

export default NotFound;
